// From https://github.com/webpack/webpack/discussions/14648#discussioncomment-1589272
var CorsWorker = /** @class */ (function () {
    function CorsWorker(url) {
        var workerScript = "\n            const scriptUrl = new URL(\"".concat(url.toString(), "\");\n            const originalImportScripts = self.importScripts;\n            self.importScripts = (url) => originalImportScripts.call(self, new URL(url, scriptUrl).toString());\n            importScripts(scriptUrl.toString());\n        ");
        var objectURL = URL.createObjectURL(new Blob([workerScript], {
            type: 'application/javascript',
        }));
        this.worker = new Worker(objectURL);
        URL.revokeObjectURL(objectURL);
    }
    CorsWorker.prototype.getWorker = function () {
        return this.worker;
    };
    return CorsWorker;
}());
export { CorsWorker };
//# sourceMappingURL=CorsWorker.js.map